import { ITEM_TYPES } from 'bto-models/betslip';
import { formatOddDisplay } from '@bto-services/utils';

// @ts-check
export default class PlayerOutcomeModel {
  /**
   * @param {import('./player.api').TOutcome} data - outcome
   * @param {import('./player.api').TPlayerMap} playerMap - player map
   */
  constructor(data, playerMap) {
    /**
     * Outcome id
     * @type {number}
     */
    this.id = data.id;
    /**
     * Flag if outcome is suspended
     * @type {boolean}
     */
    this.suspended = data.su;
    /**
     * Odd value
     * @type {string}
     */
    this.outcome = formatOddDisplay(data.o);
    this.originalOdd = data.o;
    this.originalDecimalOutcome = data.o;
    if (data.sbv) {
      /**
       * Outcome special bet value if any
       * @type {string | undefined}
       */
      this.sbv = data.sbv;
    }

    const { player, words } = data.n.split(' ').reduce((acc, n) => {
      const player = playerMap[n];
      if (player) {
        acc.player = player;
      }
      acc.words.push(player ? player.n : n);
      return acc;
    }, {
      player: null,
      words: [],
    });
    if (data.sbv) {
      words.push(`(${data.sbv})`);
    }
    /**
     * Outcome name
     * @type {string}
     */
    this.name = words.join(' ');
    if (player) {
      /**
       * Team Enum for outcome
       * @type {number}
       */
      this.teamEnum = player.t;
    }

    /**
     * Outcome identifier used for grouping of outcomes in single market
     * @type {string|null|undefined}
     */
    this.outcomeIdentifier = data.ocn;

    /**
     * Outcome Item type
     * @type {ITEM_TYPES.PRE_MATCH}
     */
    this.itemType = ITEM_TYPES.PRE_MATCH;
    if (data.i) {
      /**
       * Live outcome identifier if any
       * @type {string}
       */
      this.identifier = data.i;
    }
    if (data.sp) {
      /**
       * Live outcome specifier if any
       * @type {string}
       */
      this.specifier = data.sp;
    }
    if (typeof data.ud !== 'undefined') {
      /**
       * Live outcome upDownClass if any
       * @type {number}
       */
      this.upDownClass = data.ud;
    }
    if (typeof data.a !== 'undefined') {
      /**
       * Live outcome active property
       * @type {boolean}
       */
      this.active = data.a;
    }
  }
}